import * as React from "react";
import Menu from "material-ui-popup-state/HoverMenu";
import MenuItem from "@material-ui/core/MenuItem";
import Button from "@material-ui/core/Button";
import {
  usePopupState,
  bindHover,
  bindMenu,
} from "material-ui-popup-state/hooks";
import { makeStyles } from "@material-ui/core/styles";
import { useHistory } from "react-router-dom";
import { useDispatch } from "react-redux";
import { openCommonPageModal } from "../../redux/action/utilActions";

const useStyles = makeStyles((theme) => ({
  root: {
    [theme.breakpoints.down("md")]: {
      // backgroundColor: "white",
    },
  },
  hoverBtn: {
    backgroundColor: "transparent",
    height: "100%",
    width: "100%",
    color: "inherit",
    "&:hover": {
      backgroundColor: "transparent",
    },
  },
  menu: {
    borderBottomLeftRadius: 20,
    borderBottomRightRadius: 20,
  },
}));

const MenuPopupState = (props) => {
  const btnRef = React.useRef();
  const history = useHistory();
  const dispatch = useDispatch();
  const classes = useStyles();
  const popupState = usePopupState({ variant: "popover", popupId: "demoMenu" });
  const handleNavigate = (
    link,
    extenral,
    isModal,
    title,
    datalink,
    postlink
  ) => {
    if (isModal) {
      return dispatch(openCommonPageModal({ title, link, datalink, postlink }));
    }
    if (extenral) {
      return window.open(link, "_blank");
    }
    history.push(`/${link}`);
  };
  return (
    <React.Fragment>
      <Button
        variant="contained"
        disableElevation
        className={classes.hoverBtn}
        {...bindHover(popupState)}
        ref={btnRef}
        onClick={() => {
          handleNavigate(
            props?.link,
            props?.extenral,
            props?.isModal,
            props?.title,
            props?.datalink,
            props?.postlink
          );
        }}
      >
        {props?.children || "Menu Title"}

        {/* {props?.isModal ? "true" : "false"} */}
      </Button>
      {props?.data.length > 0 && (
        <Menu
          // disableScrollLock
          {...bindMenu(popupState)}
          getContentAnchorEl={null}
          anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
          transformOrigin={{ vertical: "top", horizontal: "left" }}
          PaperProps={
            {
              // className: classes.menu,
              // style: { width: btnRef.current.innerWidth },
            }
          }
        >
          {props?.data?.map((link, index) => {
            return (
              <MenuItem
                key={index}
                onClick={() => {
                  handleNavigate(link.link, link.external, link?.isModal);
                }}
              >
                {link.title}
              </MenuItem>
            );
          })}
        </Menu>
      )}
    </React.Fragment>
  );
};

export default MenuPopupState;
